import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment';
import httpClient from '../src/api/httpClient';

//httpClient.defaults.baseURL = "https://localhost:44372/";
//httpClient.defaults.baseURL = "https://devapibe.ultronpms.com/";


Vue.use(Vuex)

function toFixed(num, fixed) {
  var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
  return num.toString().match(re)[0];
}

export default new Vuex.Store({
  state: {
    roomRates: [],
    propertyCode: null,
    bookingInfo: [],
    arrival: null,
    departure: null,
    bookingSummary: {
      depositAmount: 0,
      depositAmountDisplay: '',
      grandTotalDisplay: '',
      grandTotal: 0,
    },
    grandBookingSummary: {},
    activeScreen: 'room',
    auth: '',
    guest: {
      firstName: "",
      lastName: "",
      email: "",
      mobileNumber: "",
      countryCode: "",
      time: "",
      specialRequests: '',
      paymentMode: null
    },
    bookingTempId: 0,
    bookedDetails: null,
    propertyInformation: null,
    ajaxingRooms: false,
    ajaxingSubSummary: false,
    selectedRoomRate: null,
    selectedRoom: null,
    roomReserve: null,
    promoCode: '',
    roomReserves: [],
    extraServices: [],
    countries: [],
    timeoutErrorMessage: '',
    errorMessage: ''
  },
  mutations: {
    setRoomTypes: function (state, payload) {
      state.roomRates = payload;
    },
    setAjaxingRooms: function (state, payload) {
      state.ajaxingRooms = payload;
    },
    setPropertyCode: function (state, payload) {
      state.propertyCode = payload;
    },
    setBookingInfo: function (state, payload) {
      state.bookingInfo.push(payload);

      let config = {
        headers: {
          'Ultron-Property-Code': state.propertyCode
        }
      }

      let body = {
        amounts: state.bookingInfo.map((item) => {
          return item.totalPrice
        })
      }

      httpClient.post('/api/v1/Property/GetSumAndDisplay', body, config).then((response) => {
        state.bookingSummary.grandTotal = response.data.data.grandTotalAmount;
        state.bookingSummary.grandTotalDisplay = response.data.data.displayGrandTotalAmount;
      }).catch(error => {
        console.log(error);
      })
    },
    setBookingSummaryGrandTotal: function (state, payload) {
      state.bookingSummary = payload;
    },
    setActiveScreen: function (state, payload) {
      state.activeScreen = payload;
    },
    removeRoom: function (state, payload) {

      // state.roomReserves.splice(payload, 1);

      state.roomReserves = state.roomReserves.filter(f => f.id !== payload.id);

      // let config = {
      //   headers: {
      //     'Ultron-Property-Code': state.propertyCode
      //   }
      // }

      // let body = {
      //   amounts: state.bookingInfo.map((item) => {
      //     return item.totalPrice
      //   })
      // }

      // httpClient.post('/api/v1/Property/GetSumAndDisplay', body, config).then((response) => {
      //   state.bookingSummary.grandTotal = response.data.data.grandTotalAmount;
      //   state.bookingSummary.grandTotalDisplay = response.data.data.displayGrandTotalAmount;
      // }).catch(error => {
      //   console.log(error);
      // })
    },
    setAuth: function (state, payload) {
      state.auth = payload;
      httpClient.defaults.headers.common['Authorization'] = `Bearer ${payload.token}`;
    },
    setBookingTempId: function (state, payload) {
      state.bookingTempId = payload;
    },
    setBookedDetails: function (state, payload) {
      state.bookedDetails = payload;
    },
    setSelectedRoomRate: function (state, payload) {
      state.selectedRoomRate = payload;
    },
    setSelectedRoom: function (state, payload) {
      state.selectedRoom = payload;
    },
    setPropertyInformation: function (state, payload) {
      state.propertyInformation = payload;
    },
    setRoomReserve: function (state, payload) {
      state.roomReserve = payload;
    },
    setExtraServices: function (state, payload) {
      state.extraServices = payload;
    },
    setRoomReserves: function (state, payload) {
      state.roomReserves.push(payload);
    },
    setGrandBookingSummary: function (state, payload) {
      state.grandBookingSummary = payload;
    },
    setCountries: function (state, payload) {
      state.countries = payload;
    },
    clearRoomReserves: function (state) {
      state.roomReserves = [];
    },
    setTimeoutErrorMessage: function (state, payload) {
      state.timeoutErrorMessage = payload
    },
    setErrorMessage: function (state, payload) {
      state.errorMessage = payload
    }
  },
  getters: {
    GetRooms: state => {
      return () => {
        return state.roomRates
      }
    },
    GetBookingInfo: state => {
      return () => {
        return state.bookingInfo
      }
    },
    GetArrival: state => {
      return () => {
        return state.arrival;
      }
    },
    GetDeparture: state => {
      return () => {
        return state.departure;
      }
    },
    GetBookingSummary: state => {
      return () => {
        return state.bookingSummary;
      }
    },
    GetActiveScreen: state => {
      return () => {
        return state.activeScreen;
      }
    },
    GetGuest: state => {
      return () => {
        return state.guest;
      }
    },
    GetBookedDetails: state => {
      return () => {
        return state.bookedDetails;
      }
    },
    GetAjaxingRooms: state => {
      return () => {
        return state.ajaxingRooms;
      }
    },
    GetSubSummaryAjaxing: state => {
      return () => {
        return state.ajaxingSubSummary;
      }
    },
    GetSelectedRoomRate: state => {
      return () => {
        return state.selectedRoomRate;
      }
    },
    GetSelectedRoom: state => {
      return () => {
        return state.selectedRoom;
      }
    },
    GetPropertyInformation: state => {
      return () => {
        return state.propertyInformation;
      }
    },
    GetRoomReserve: state => {
      return () => {
        return state.roomReserve;
      }
    },
    GetExtraServices: state => {
      return () => {
        return state.extraServices;
      }
    },
    GetRoomReserves: state => {
      return () => {
        return state.roomReserves;
      }
    },
    GetGrandBookingSummary: state => {
      return () => {
        return state.grandBookingSummary;
      }
    },
    GetPropertyCode: state => {
      return () => {
        return state.propertyCode;
      }
    },
    GetPromoCode: state => {
      return () => {
        return state.promoCode;
      }
    },
    GetCountries: state => {
      return () => {
        return state.countries;
      }
    },
    GetCountry: (state) => (code) => {
      return () => {
        return state.countries.find((c) => { return c.code.trim() === code.trim() });
      }
    },
    GetPaymentModes: (state) => {
      return () => {
        return state.propertyInformation.bePaymentSettings;
      }
    },
    GetBookingPolicy: (state) => {
      return () => {
        return state.propertyInformation.bookingPolicy;
      }
    },
    GetPropertyInfo: (state) => {
      return () => {
        if (state.propertyInformation)
          return state.propertyInformation.bePropertyInfo;
      }
    },
    GetPropertyFacilitiesAndServices: (state) => {
      return () => {
        if (state.propertyInformation)
          return state.propertyInformation.propertyFeatures;
      }
    },
    GetTimeoutErrorMessage: (state) => {
      return () => {
        return state.timeoutErrorMessage;
      }
    },
    GetErrorMessage: (state) => {
      return () => {
        return state.errorMessage;
      }
    }
  },
  actions: {
    getRoomTypeAvailabilityAndRates: function ({ commit, state, dispatch }, payload) {

      state.arrival = payload.startDate;
      state.departure = payload.endDate;
      state.promoCode = payload.promoCode;

      let config = {
        headers: {
          'Ultron-Property-Code': state.propertyCode
        },
        params: {
          StartDate: payload.startDate,
          EndDate: payload.endDate,
          GatewayPropertyId: state.propertyCode,
          PromoCode: payload.promoCode
        }
      }
      commit('setAjaxingRooms', true);




      httpClient.get('/api/v1/BookingEngine/GetRoomAvailabilityAndRate', config).then((response) => {
        commit('setRoomTypes', response.data.data);
        dispatch('minusAvailabilitySelectRooom');
        commit('setAjaxingRooms', false);
        if(!response.data.success){
        commit('setErrorMessage', response.data.message);
        }else{
        commit('setErrorMessage', '');
        }
      }).catch(error => {
        commit('setAjaxingRooms', false);
        console.log(error);
      });
    },
    getSumAndDisplay: function ({ commit, state }, payload) {



      let config = {
        headers: {
          'Ultron-Property-Code': state.propertyCode
        }
      }

      let body = {
        amount: payload
      }

      return new Promise((resolve, reject) => {

        httpClient.post('/api/v1/Property/GetSumAndDisplay', body, config).then((response) => {
          commit('setBookingSummaryGrandTotal', response.data.data);
          resolve(response.data.data);
        }).catch(error => {
          console.log(error);
        })
      });
    },
    getAmountDisplay: async function ({ commit, state }, payload) {



      let config = {
        headers: {
          'Ultron-Property-Code': state.propertyCode
        }
      }

      let body = {
        amount: payload
      }


      return await httpClient.post('/api/v1/Property/GetAmountDisplay', body, config);

      // return new Promise((resolve, reject) => {

      //   httpClient.post('/api/v1/Property/GetAmountDisplay', body, config).then((response) => {
      //     resolve(response.data.data);
      //   }).catch(error => {
      //     console.log(error);
      //   })
      // });
    },
    getDepositAndGrandTotal: function ({ commit, state }, payload) {



      let config = {
        headers: {
          'Ultron-Property-Code': state.propertyCode
        }
      }

      let body = {
        amount: 0,
        amounts: payload.amounts,
        depositPercentage: payload.depositPercentage,
        depositPolicy: payload.depositPolicy
      }

      state.ajaxingSubSummary = true;

      return new Promise((resolve, reject) => {

        httpClient.post('/api/v1/Property/ComputeDeposit', body, config).then((response) => {
          state.ajaxingSubSummary = false;
          resolve(response.data.data);

        }).catch(error => {
          state.ajaxingSubSummary = false;
          console.log(error);
        }).finally(() => {
          state.ajaxingSubSummary = false;
        })
      });
    },
    getDepositAndGrandTotalMany: function ({ commit, state }, payload) {



      let config = {
        headers: {
          'Ultron-Property-Code': state.propertyCode
        }
      }

      let body = {
        payload
      }

      return new Promise((resolve, reject) => {

        httpClient.post('/api/v1/Property/ComputeDepositMany', payload, config).then((response) => {
          resolve(response.data.data);
        }).catch(error => {
          console.log(error);
        })
      });
    },
    setPropertyCode: function ({ commit, state }, payload) {
      commit('setPropertyCode', payload);
    },
    addBookingInfo: function ({ commit, state }, payload) {
      commit('setBookingInfo', payload);
    },
    setActiveScreen: function ({ commit, state }, payload) {
      commit('setActiveScreen', payload);
    },
    removeRoom: function ({ commit, state }, payload) {

      commit('removeRoom', payload);
      let roomTypeId = payload.room.beRoomTypeId;

      if (payload.ratePlan.hotDealsType === 'PackageDeal' || payload.ratePlan.hotDealsType === 'PayStayDeal') {
        roomTypeId = payload.ratePlan.room.beRoomTypeId;
      } else {
        roomTypeId = payload.room.beRoomTypeId;
      }

      let roomUnit = 1;
      for (let count = 0; count < state.roomRates.length; count++) {
        if (state.roomRates[count].beRoomTypeId === roomTypeId) {
          state.roomRates[count].availability += roomUnit;
        }
      }
    },
    clearRoomReserves: function ({ commit, state }, payload) {

      commit('clearRoomReserves');
    },
    setAuth: function ({ commit, state }, payload) {

      commit('setAuth', payload);
    },
    loginAuth: function ({ state, commit }) {

      const body = {
        "userName": "admin",
        "password": "88888888"
      }

      return new Promise((resolve, reject) => {

        httpClient.post('/api/v1/Authentication/login', body).then((response) => {
          resolve(response.data);
          commit('setAuth', { token: response.data.accessToken, userId: response.data.applicationUser.userAccountId });
        }).catch(error => {
          console.log(error);
        })
      });
    },
    bookNow: function ({ state, commit }) {
      const config = {
        headers: {
          'Ultron-Property-Code': state.propertyCode
        }
      };

      let bookingStatus = "Cancel";
      let paymentMode = 3;
      if (state.guest.paymentMode === 'BankTransfer') {//BANK TRANSFER
        bookingStatus = "Unconfirm";
        paymentMode = 3;
      }
      else if (state.guest.paymentMode === 'PaymentPending') { //ONLINE PAYMENT (DEBIT/CREDIT CARD)
        paymentMode = 4;
        bookingStatus = "Unconfirm"; //CANCEL - will auto update to confirm when after make successful payment
      } else if (state.guest.paymentMode !== 'BankTransfer') { //ONLINE PAYMENT (DEBIT/CREDIT CARD)
        paymentMode = 2;
        bookingStatus = "Cancel"; //CANCEL - will auto update to confirm when after make successful payment
      }

      let body = {
        "gatewayPropertyId": state.propertyCode,
        "bookingDate": (new Date()).toISOString(),
        "orderDateTime": (new Date()).toISOString(),
        "depositAmount": Number(state.grandBookingSummary.depositAmount),
        "notes": state.guest.specialRequests,
        "promoCode": state.promoCode,
        "beGuest": {
          "firstName": state.guest.firstName,
          "lastName": state.guest.lastName,
          "email": state.guest.email,
          "mobileNumber": state.guest.mobileNumber,
          "countryCode": state.guest.countryCode
        },
        "paymentMode": paymentMode,
        "beRoomStays": [
          ...state.roomReserves.map((sr) => {
            let room = sr;

            let chargeList = [];
            let chargeExtraList = [];
            let totalExtraPersonCharge = 0;
            for (let price = 0; price < room.services.length; price++) {
              if (Number(room.services[price].id) !== 0) {

                let dates = room.services[price].description.split(',');


                let quantity = room.services[price].quantity / dates.length;


                let amount = room.services[price].amount;

                if (room.services[price].isMandatory === false && room.services[price].bookingExtraType !== 'PerNight' && dates.length !== 1) {
                  amount = amount / quantity;
                }

                if (room.services[price].bookingExtraType === 'PerNight') {
                  amount = amount / dates.length;
                }



                for (let d = 0; d < dates.length; d++) {
                  chargeExtraList.push({
                    amount: amount,
                    transactionDate: dates[d], //subject to change on room.services[price].date DONT FORGET
                    chargeRoomDate: new Date(), //subject to change on room.services[price].date DONT FORGET,
                    description: `${room.services[price].tempDescription !== undefined ? room.services[price].tempDescription : ''}`,
                    beExtraServiceId: room.services[price].id,
                    quantity: quantity,
                    addOnType: room.services[price].addOnType,
                    showOptional: room.services[price].showOptional
                  })
                }


              } else {
                totalExtraPersonCharge += room.services[price].amount;
              }

            }

            let differenceDecimal = Number((totalExtraPersonCharge - (toFixed(totalExtraPersonCharge / room.ratePlan.priceList.length, 2) * room.ratePlan.priceList.length)).toFixed(2));

      

            for (let price = 0; price < room.ratePlan.priceList.length; price++) {
              let extraPersonCharge = Number(toFixed(totalExtraPersonCharge / room.ratePlan.priceList.length, 2));
              if (price == 0) {
                extraPersonCharge += Number(toFixed(differenceDecimal, 2));
              }
              chargeList.push({
                amount: room.ratePlan.priceList[price].price,
                transactionDate: room.ratePlan.priceList[price].date,
                chargeRoomDate: room.ratePlan.priceList[price].date,
                extraPersonCharge: extraPersonCharge
              })
            }

            let beRoomTypeId = 0;
            if (room.ratePlan.hotDealsType === 'PackageDeal' || room.ratePlan.hotDealsType === 'PayStayDeal') {
              beRoomTypeId = room.ratePlan.room.beRoomTypeId;
            } else {
              beRoomTypeId = room.room.beRoomTypeId;
            }

            return {
              "arrivalDate": sr.startDate,
              "departureDate": sr.endDate,
              "beRoomTypeId": beRoomTypeId,
              "beRatePlanId": room.ratePlan.ratePlanId,
              "beRoomCharges": chargeList,
              "beRoomChargeExtras": chargeExtraList,
              "child": sr.child,
              "adult": sr.adult,
              "beHotDealId": room.ratePlan.hotDealId,
              "bookingStatus": bookingStatus,
              "EstimatedArrivalTime": state.guest.time,
              "hotDealName": room.ratePlan.hotDealName
            }
          })
        ]
      }
      return new Promise((resolve, reject) => {

        httpClient.post('/api/v1/BookingEngine/AddReservation', body, config).then((response) => {
          let { data, success, message } = response.data;

          if (!success) {
            throw message;
          }

          commit('setBookingTempId', data.id);

          resolve(data);

        }).catch((error) => {
          console.log(error);
        });
      });
    },
    createBooking: function ({ state, commit }, payload) {
      const config = {
        headers: {
          'Ultron-Property-Code': state.propertyCode
        }
      }

      const body = {
        "bookingTempId": state.bookingTempId,
        "transactionCode": '',
        "paymentModeTypeId": ''
      }

      return new Promise((resolve, reject) => {

        httpClient.post('/api/v1/Booking/Create', body, config).then((response) => {
          commit('setBookingTempId', response.data.data.bookingId);
          resolve(response.data.data);
        }).catch(error => {
          console.log(error);
        })
      });
    },
    getBookingDetailsById: function ({ commit, state }, payload) {
      const config = {
        headers: {
          'Ultron-Property-Code': state.propertyCode
        }
      };

      const body = {
        "orderCode": payload,
        "gatewayPropertyId": state.propertyCode
      }

      state.ajaxingRooms = true;

      httpClient.post('/api/v1/BookingEngine/GetReservation', body, config).then((response) => {
        let { data } = response.data;


        if (!data) {
          throw 'No results found.'
        }

        commit('setBookedDetails', data);
        state.ajaxingRooms = false;


        state.guest = {
          firstName: "",
          lastName: "",
          email: "",
          mobileNumber: "",
          countryCode: "",
          time: "",
          specialRequests: '',
          paymentMode: null
        }

        if (data.beRoomStays !== null && data.beRoomStays !== undefined && data.beRoomStays.length !== 0) {
          state.arrival = data.beRoomStays[0].arrivalDate;
          state.departure = data.beRoomStays[0].departureDate;
        }


      }).catch((error) => {
        state.ajaxingRooms = false;

        console.log(error);

      }).finally(() => {
        state.ajaxingRooms = false;
      });
    },
    getPropertyInformation: function ({ commit, state }, payload) {
      let config = {
        headers: {
          'Ultron-Property-Code': state.propertyCode
        },
        params: {
          GatewayPropertyId: state.propertyCode
        }
      }


      httpClient.get('/api/v1/BookingEngine/GetPropertyInformation', config).then((response) => {
        commit('setPropertyInformation', response.data.data);
      }).catch(error => {
        console.log(error);
      });
    },
    getExtraService: function ({ commit, state }) {
      let config = {
        headers: {
          'Ultron-Property-Code': state.propertyCode
        },
        params: {
          GatewayPropertyId: state.propertyCode
        }
      }


      httpClient.get('/api/v1/BookingEngine/GetExtraService', config).then((response) => {
        commit('setExtraServices', response.data.data);
      }).catch(error => {
        console.log(error);
      });
    },
    setSelectedRoomRate: function ({ commit, state }, payload) {
      commit('setSelectedRoomRate', payload);
    },
    setSelectedRoom: function ({ commit, state }, payload) {
      commit('setSelectedRoom', payload);
    },
    setRoomReserve: function ({ commit, state }, payload) {
      commit('setRoomReserve', payload);
    },
    setRoomReserves: function ({ commit, state }, payload) {
      commit('setRoomReserves', payload);
    },
    fetchCountries: function ({ commit, state }, payload) {

      let config = {
        headers: {
          'Ultron-Property-Code': state.propertyCode
        }
      }




      httpClient.get('/api/v1/Country/GetAll', config).then((response) => {
        commit('setCountries', response.data);
      }).catch(error => {
        commit('setCountries', []);
        console.log(error);
      });
    },
    deductRoomAvailability: function ({ commit, state }, payload) {
      let roomTypeId = payload.roomTypeId;
      let roomUnit = payload.roomUnit;
      for (let count = 0; count < state.roomRates.length; count++) {
        if (state.roomRates[count].beRoomTypeId === roomTypeId) {
          state.roomRates[count].availability -= roomUnit;
        }
      }
    },
    minusAvailabilitySelectRooom: function ({ commit, state }) {

      let roomReserves = state.roomReserves;

      let arrival = state.arrival;
      let tempdeparture = new Date(state.departure);

      tempdeparture.setDate(tempdeparture.getDate() - 1);
      let departure = moment(tempdeparture).format('YYYY-MM-DD');


      let tempList = [];

      while (arrival <= departure) {
        for (let counter = 0; counter < roomReserves.length; counter++) {
          let priceList = roomReserves[counter].ratePlan.priceList;
          if (priceList !== null && priceList.length !== 0) {
            for (let icounter = 0; icounter < priceList.length; icounter++) {

              if (arrival === moment(priceList[icounter].date).format('YYYY-MM-DD')) {

                if (roomReserves[counter].ratePlan.hotDealsType === 'PackageDeal' || roomReserves[counter].ratePlan.hotDealsType === 'PayStayDeal') {
                  tempList.push({ roomTypeId: roomReserves[counter].ratePlan.beRoomTypeId, id: roomReserves[counter].id });
                } else {
                  tempList.push({ roomTypeId: roomReserves[counter].room.beRoomTypeId, id: roomReserves[counter].id });
                }
                icounter = priceList.length;
              }
            }
          }
        }

        let temparrival = new Date(arrival);

        temparrival.setDate(temparrival.getDate() + 1);
        arrival = moment(temparrival).format('YYYY-MM-DD');
      }


      let removedDuplicates = [...new Map(tempList.map((m) => [m.id, m])).values()];
      
      for (let count = 0; count < removedDuplicates.length; count++) {
        let roomTypeId = removedDuplicates[count].roomTypeId;
        for (let icount = 0; icount < state.roomRates.length; icount++) {
          if (state.roomRates[icount].beRoomTypeId === roomTypeId) {
            state.roomRates[icount].availability -= 1;
          }
        }
      }

    }

  }
})
